import React from "react";
import styles from "./style.module.css";
import moment from "moment";
import numeral from "numeral";

import { Popover, OverlayTrigger, Badge } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCalendarAlt, faCalendarDay, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem, Icon } from "aible";

import TileEditIcon from "images/Next-Icons/TileEditIcon.svg";
import TilePinIcon from "images/Next-Icons/TilePinIcon.svg";
import TileTodoIcon from "images/Next-Icons/TileTodoIcon.svg";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import HexGridContainer from "containers/Next/HexGrid";
import MonitoringSummaryContainer from "containers/Next/Monitoring/MonitoringSummary";

import { getConversationArray } from "containers/ChatGPT/reducer";

export default class ExplorationTile extends React.PureComponent {
  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  getChatMetrics() {
    const { data, getChatMetrics } = this.props;

    const conversations = data?.metadata?.chatGPTConvo?.conversation;
    const convArr = getConversationArray(undefined, conversations);

    return getChatMetrics(convArr);
  }

  render() {
    const { data, handleDelete, handleMoveReport, onClick } = this.props;

    const hexMap = data?.metadata?.next?.hexMap || data?.metadata?.hexMap;

    const explorationKeys = Object.keys(data?.metadata?.explorations ?? {}) || [];
    const latestExplorationKey = Math.max(...explorationKeys);
    const exploration = data?.metadata?.explorations?.[latestExplorationKey] ?? data?.metadata?.explorations?.[0];

    const label = exploration?.reportLabel || data?.name;

    const hasProject = exploration?.projectId !== undefined;

    const targetValue = exploration?.targetColumn;
    const subgroupCol = exploration?.splitColumn;

    const hasTargetValue = targetValue !== undefined;
    const hasSubgroupCol = subgroupCol !== undefined;

    const { prompts, totalTokens, totalCost, totalCharacters } = this.getChatMetrics();

    const hasChats = false && Boolean(prompts || totalTokens);

    const hasTokens = totalTokens > 0;
    const hasCharacters = totalCharacters > 0;

    return (
      <div className={styles.chatTileWrapping}>
        <Tile
          onClick={onClick}
          buttonText={"Open Chat"}
          handleDelete={handleDelete ? (e) => this.handleDelete(e) : undefined}
          // TODO: Move folder
          //handleMoveFolder={() => handleMoveReport(data?.id)}
          style={{ width: "auto", height: "auto" }}
        >
          {hasProject && false && <div className={styles.hasProject}>{"Has Models"}</div>}
          <TileTitle title={label} color={"rgb(126, 105, 215)"} icon={"projectSegments"} style={{ color: "white" }}>
            {"(" + data.id + ") " + label}
          </TileTitle>
          {(hasTargetValue || hasSubgroupCol) && (
            <React.Fragment>
              <div className={styles.exploreTitleExtension} style={{ background: "rgb(126, 105, 215)" }} />
              <div className={styles.exploreSubTitle}>
                {hasTargetValue && (
                  <div className={styles.exploreSubTitleContent}>
                    <Icon type={"target"} size={16} />
                    <strong style={{ marginLeft: "6px", marginTop: "2px" }}>{targetValue}</strong>
                  </div>
                )}
                {hasSubgroupCol && (
                  <div className={styles.exploreSubTitleContent}>
                    <Icon type={"pieChart"} size={16} />
                    <span style={{ marginLeft: "6px", marginTop: "2px" }}>{subgroupCol}</span>
                  </div>
                )}
              </div>
            </React.Fragment>
          )}
          <TileBody
          // style={{
          //   marginBottom: spacerSize
          // }}
          >
            {hasChats && (
              <React.Fragment>
                <TileItem icon={"chatLines"}>{prompts + " Prompts"}</TileItem>
                <TileItem icon={"gear"}>
                  {(hasTokens ? totalTokens + " Tokens" : "") +
                    (hasTokens && hasCharacters ? " and " : "") +
                    (hasCharacters ? totalCharacters + " Characters" : "") +
                    " Used"}
                </TileItem>
                <TileItem icon={"money"}>{`$${numeral(totalCost).format("0.00[00]")} Total Cost (estimate)`}</TileItem>
              </React.Fragment>
            )}
            {data?.dataset?.label ? <TileItem icon={"dataset"}>{data?.dataset?.label}</TileItem> : null}
            {hexMap && <TileItem icon={"chart"}>{Object.keys(hexMap).length + " charts"}</TileItem>}
            {data.created_date ? (
              <TileItem
                icon={"calendar"}
                overlay={moment.utc(data.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(data.created_date).local().fromNow()}
              </TileItem>
            ) : (
              ""
            )}
            {data.created_by ? (
              <TileItem icon={"user"}>
                {data.created_by.fullname !== undefined ? data.created_by.fullname : data.created_by}
              </TileItem>
            ) : (
              ""
            )}
          </TileBody>
        </Tile>
      </div>
    );
  }
}
